import React, { useState, useEffect } from 'react';

function WeatherCard({ temp, humidity, pressure, weatherMood, name, speed, country, sunset }) {
    const [weatherstate, setWeatherState] = useState('wi wi-dust');

    useEffect(() => {
        if (weatherMood) {
            switch (weatherMood) {
                case 'Clouds':
                    setWeatherState('wi wi-cloudy');
                    break;
                case 'Haze':
                    setWeatherState('wi wi-smog');
                    break;
                case 'Clear':
                    setWeatherState('wi-day-sunny');
                    break;
                case 'Rain':
                    setWeatherState('wi-day-rain');
                    break;

                default:
                    setWeatherState('wi-day-sunny');
                    break;
            }
        }
    }, [weatherMood]);

    //time converting
    let sec = sunset;
    let date = new Date(sec + 1000);
    let timeStr = `${date.getHours()} : ${date.getMinutes()}`;
    return (
        <>
            <div className="weather-card-wrapper">
                <div className="widget">
                    <div className="weatherIcon">
                        <i className={`wi ${weatherstate}`}></i>
                    </div>
                    <div className="weatherInfo">
                        <div className="temperature">
                            <span>
                                {temp}
                                <i className={'wi wi-celsius'}></i>
                            </span>
                        </div>
                        <div className="description">
                            <div className="weatherCondition">{weatherMood}</div>
                            <div className="place">
                                {name}, {country}
                            </div>
                        </div>
                    </div>
                    <div className="date">{new Date().toLocaleDateString()}</div>
                    {/* footer section */}
                    <div className="extra-temp">
                        <div className="temp-info-minmax">
                            <div className="two-sided-section">
                                <p>
                                    <i className={'wi wi-sunset'}></i>
                                </p>
                                <p className="extra-info-leftside">
                                    {timeStr} PM <br />
                                    Sunset
                                </p>
                            </div>
                            <div className="two-sided-section">
                                <p>
                                    <i className={'wi wi-thermometer'}></i>
                                </p>
                                <p className="extra-info-leftside">
                                    {humidity} <br />
                                    Humidity
                                </p>
                            </div>
                        </div>
                        <div className="weather-extra-info">
                            <div className="two-sided-section">
                                <p>
                                    <i className={'wi wi-wind-beaufort-11'}></i>
                                </p>
                                <p className="extra-info-leftside">
                                    {pressure} <br />
                                    Pressure
                                </p>
                            </div>
                            <div className="two-sided-section">
                                <p>
                                    <i className={'wi wi-barometer'}></i>
                                </p>
                                <p className="extra-info-leftside">
                                    {speed} <br />
                                    Speed
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WeatherCard;
